import { ProductParams } from 'types/getParams';

import { TProduct } from '../../../types/product';
import { CRMAPIBase } from '../../crmApiBase';
import { ProductListResp } from '../../responseModels/product/productListResponse';
import { ProductResp } from '../../responseModels/product/productResponse';
import { RequestResult } from '../../responseModels/requestResult';
import { ServiceListResp } from '../../responseModels/service/serviceListResponse';

class ProductGroup extends CRMAPIBase {
    /**
     * Добавление товара
     * @param product Товар
     * @returns Результат запроса
     */
    async saveProduct(product: TProduct): Promise<RequestResult<ProductResp>> {
        const result = await this.post<ProductResp>('/products', { ...product });
        return result;
    }

    /**
     * Получение товара
     * @param id ID товара
     * @param crmId ID CRM
     * @returns Результат запроса
     */
    async getProduct(
        id: number,
        crmId: number,
        is_permission?: boolean
    ): Promise<RequestResult<ProductResp>> {
        const result = await this.get<ProductResp>(`/products/${id}`, {
            crm_id: crmId,
            is_permission,
        });
        return result;
    }
    /**
     * Получение списка товаров
     * @param params Параметры получения списка товаров
     * @returns Результат запроса
     */
    async getProductByBarcode({
        crm_id,
        barcode,
    }: {
        crm_id: number;
        barcode: number;
    }): Promise<RequestResult<ProductResp>> {
        const result = await this.get<ProductResp>(`/products/barcode/${barcode}`, {
            crm_id,
        });
        return result;
    }
    /**
     * Получение списка товаров
     * @param params Параметры получения списка товаров
     * @param page Страница
     * @param perPage На страницу
     * @returns Результат запроса
     */
    async getProductList(params: ProductParams): Promise<RequestResult<ProductListResp>> {
        const result = await this.get<ProductListResp>('/products', {
            ...params,
        });
        return result;
    }

    /**
     * Обновление товара
     * @param product Товар
     * @returns Результат запроса
     */
    async updateProduct(product: TProduct): Promise<RequestResult<ProductResp>> {
        const result = await this.put<ProductResp>(`/products/${product.id || product.product_id}`, { ...product });
        return result;
    }

    /**
     * Удаление товара
     * @param id ID товара
     * @param crmId ID CRM
     * @returns Результат запроса
     */
    async removeProduct(id: number, crmId: number): Promise<RequestResult<ProductResp>> {
        const result = await this.delete<ProductResp>(`/products/${id}`, { crm_id: crmId });
        return result;
    }

    /**
     * Восстановление товара
     * @param id ID товара
     * @param crmId ID CRM
     * @returns Результат запроса
     */
    async restoreProduct(id: number, crmId: number): Promise<RequestResult<ProductResp>> {
        const result = await this.post<ProductResp>(`/products/${id}/restore`, { crm_id: crmId });
        return result;
    }

    /**
     * Получение списка услуг товара
     * @param id ID товара
     * @param crmId ID CRM
     * @returns Результат запроса
     */
    async getProductServiceList(
        id: number,
        crmId: number
    ): Promise<RequestResult<ServiceListResp>> {
        const result = await this.get<ServiceListResp>(`/products/${id}/services`, {
            crm_id: crmId,
        });
        return result;
    }

    /**
     * Обновление категорий товаров
     * @param crmId ID CRM
     * @param products Карта перемещений
     * @returns Результат запроса
     */
    async updateProductCategories(
        crmId: number,
        products: Array<{ id: number; product_category_id: number }>
    ): Promise<RequestResult<ProductListResp>> {
        const result = await this.post<ProductListResp>('/products/categories', {
            crm_id: crmId,
            products: products,
        });
        return result;
    }
}

export { ProductGroup };
